<ion-header class="ion-no-border" mode="md">
  <ion-toolbar>
    <ion-title>{{ 'IFT_NOTE_TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="agreement-content">
    <div class="notice-block">
      <div class="notice-number">1.</div>
      <div class="notice-text">
        {{ 'IFT_NOTE' | translate:{ appVersion: appVersion } }}
      </div>
    </div>

    <div class="notice-block">
      <div class="notice-number">2.</div>
      <div class="notice-text">
        {{ 'SWSAS_IFT_NOTE' | translate }}
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <div class="ion-padding">
    <ion-item lines="none" class="checkbox-item">
      <ion-checkbox slot="start" [(ngModel)]="accepted"></ion-checkbox>
      <ion-label (click)="toggleAccepted()">{{ 'IFT_NOTE_ACCEPT' | translate }}</ion-label>
    </ion-item>
    <ion-button expand="block" [disabled]="!accepted" (click)="continue()">
      {{ 'accept' | translate }}
    </ion-button>
  </div>
</ion-footer>